import { Component, input, model, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Checkbox } from 'primeng/checkbox';
import { Button } from 'primeng/button';
import { Tag } from 'primeng/tag';

/**
 * Chrome around an overridable realm config section: an "override category default"
 * toggle, an inheritance note, and reset / fill-from controls. The actual editor is
 * projected in via <ng-content>; the host tab owns the draft/overridden models.
 */
@Component({
    selector: 'app-overridable-section',
    standalone: true,
    imports: [FormsModule, Checkbox, Button, Tag],
    templateUrl: './overridable-section.html',
})
export class OverridableSection {
    readonly title = input.required<string>();
    readonly overridden = model.required<boolean>();
    readonly dirty = input<boolean>(false);
    /** Where the inherited value comes from, e.g. "Category". */
    readonly sourceText = input<string>('Category');
    /** Whether to show the "Fill from…" import control. */
    readonly importable = input<boolean>(true);
    /** Width cap for the section card; widen for long-form editors. */
    readonly widthClass = input<string>('max-w-xl');

    readonly reset = output<void>();
    readonly importFrom = output<void>();
}
